import { useRequestErrorToast } from '@onefootprint/hooks';
import type { PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ConfirmationDialog from '@/components/confirmation-dialog';
import usePlaybooks from '@/pages/playbooks/hooks/use-playbooks';
import useUpdatePlaybook from '@/pages/playbooks/hooks/use-update-playbook';
export type StatusHandler = {
  toggle: () => void;
};
export type StatusProps = {
  playbook: PlaybookVersionNoGraph;
};
const Status = forwardRef<StatusHandler, StatusProps>(({
  playbook: obc
}, ref) => {
  const {
    refetch
  } = usePlaybooks();
  const {
    t
  } = useTranslation('playbooks', {
    keyPrefix: 'table.actions.status'
  });
  const [open, setOpen] = useState(false);
  const mutation = useUpdatePlaybook();
  const showErrorToast = useRequestErrorToast();
  const hideConfirmation = () => {
    setOpen(false);
  };
  const disable = () => {
    mutation.mutate({
      body: {
        status: obc.status === 'enabled' ? 'disabled' : 'enabled'
      },
      path: {
        id: obc.playbookId
      },
      url: '/org/playbooks/{id}'
    }, {
      onSuccess: () => {
        hideConfirmation();
        refetch();
      },
      onError: (error: unknown) => {
        showErrorToast(error);
      }
    });
  };
  const handleToggle = () => {
    if (obc.status === 'enabled') {
      setOpen(true);
    } else {
      disable();
    }
  };
  useImperativeHandle(ref, () => ({
    toggle: handleToggle
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return <ConfirmationDialog isPending={mutation.isPending} onClose={hideConfirmation} onConfirm={disable} open={open} title={obc.status === 'enabled' ? t($ => $.disable.confirmation.title) : t($ => $.enable.confirmation.title)}>
      <Trans ns="playbooks" i18nKey={obc.status === 'enabled' ? $ => $.table.actions.status.disable.confirmation.description : $ => $.table.actions.status.enable.confirmation.description} components={{
      b: <b className="text-label-2" />
    }} values={{
      name: obc.name
    }} />
    </ConfirmationDialog>;
});
export default Status;